import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { CourseCoursesBridge } from './bridges/course_courses.bridge';
import { COURSES_FEATURE_KEY } from './keys';
import { coursesReducer } from './reducers/courses.reducer';
import { CoursesEffects } from './effects/courses.effects';

export function provideCoursesStore(): EnvironmentProviders[] {
    return [provideState(COURSES_FEATURE_KEY, coursesReducer), provideEffects(CoursesEffects, CourseCoursesBridge)];
}
